import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  currentPage: 'forecast-project',
};

const slice = createSlice({
  name: 'navigation',
  initialState,
  reducers: {
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
  },
});

export const { setCurrentPage } = slice.actions;
export default slice.reducer;
